import { css } from '@mui/material';

export const breakpoints = {
  desktopOnly: 'screen and (min-width: 960.99px)',
  mobile: 'screen and (max-width: 960px)',
};

export const breakpoint =
  (key: keyof typeof breakpoints) =>
  (...args: Parameters<typeof css>) => {
    const styles = css(...args);
    return (props: { theme: { breakpoints: typeof breakpoints } }) =>
      css`
        @media ${props.theme.breakpoints[key]} {
          ${styles}
        }
      `;
  };

export default breakpoints;
